import { render, staticRenderFns } from "./ace-modal.vue?vue&type=template&id=23da4c94"
import script from "./ace-modal.vue?vue&type=script&lang=ts"
export * from "./ace-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports